import { Link } from 'react-router-dom';
import './StickyQuoteButton.css';

/** Floating "Get a Quote" pill, stacked directly above the Chatbot FAB (bottom-right, every page). */
export default function StickyQuoteButton() {
  return (
    <Link to="/contact" className="sticky-quote-btn" aria-label="Get a quote">
      <span className="sticky-quote-btn__dot" aria-hidden="true" />
      Get a Quote
    </Link>
  );
}
